import React from "react";
import classnames from "classnames";
import { PlusIcon, VerticalDotsIcon } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";

import {
    setIsHistoryModalOpened,
    setIsInlineErrorCleared,
    store as choiceStore,
    setIsActionsClicked,
    setIsEdited,
    setActions,
    setIsLoading,
} from "../store";
import { store } from "@components/VerticalLayout/store";

import ErrorToast from "@components/Common/ErrorTost";
import { clearMultiCustomSelectionData } from "@components/Common/MultiCustomSelect/store";
import { clearData } from "@components/Common/MultiCustomCreatableSelection/store";
import { ArchivedValidationModal } from "@components/Common/ArchivedValidationModal";

import { CustomMainColorIconButton } from "@components/Common/CustomMainColorIconButton";
import { CustomMainColorButtonWithIcon } from "@components/Common/CustomMainColorButtonWithIcon";
import {
    ArchivedPaymentMethod,
    ArchivedPaymentMethodFranchise,
    handleArchivePaymentMethods,
    isSaleSupportArchived,
    paymentMethodExistInShops,
    PaymentMethodExistInShopsActivated,
} from "./hooks";
import { useFetchGlobal } from "../../../../api/hooks";

type CustomSideFilterType = {
    selectedRows: any;
    setIsInInitializationModalOpened: any;
    setDataIsUpdated: any;
    choice: any;
    setLocalFilterActive: any;
    setIsAddChoiceClicked: Function;
    isAddChoiceClicked: boolean;
    setIsModalConfirmationOpened: Function;
    isModalConfirmationOpened: boolean;
    isArchivedPaymentMethodsClicked: boolean;
    setIsArchivedPaymentMethodsClicked: Function;
};

export function CustomSideFilter({
    selectedRows,
    setIsInInitializationModalOpened,
    setDataIsUpdated,
    choice,
    setLocalFilterActive,
    setIsAddChoiceClicked,
    isAddChoiceClicked,
    setIsModalConfirmationOpened,
    isModalConfirmationOpened,
    isArchivedPaymentMethodsClicked,
    setIsArchivedPaymentMethodsClicked,
}: CustomSideFilterType) {
    const { t } = useTranslation();
    const {
        numberActive,
        numberArchived,
        isHistoryModalOpened,
        shopsPaymentMethodsData,
        isInlineErrorCleared,
        listFranchiseArchived,
        isActionsClicked,
        isEdited,
        modify,
        isLoading,
    } = useSnapshot(choiceStore);
    const { userID, franchiseID, oneShop, operatorID, shopID } = useSnapshot(
        store
    );
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const uuidUser = localStorage.getItem("uuidUser");
    const { fetchGlobal } = useFetchGlobal();
    const shopId = oneShop ? shopID : 0;
    let dataArchive: any[] = [];
    if (!oneShop) {
        dataArchive = ArchivedPaymentMethod(shopsPaymentMethodsData);
    } else {
        dataArchive = ArchivedPaymentMethodFranchise(listFranchiseArchived);
    }

    const [
        isArchivedValidationModalOpened,
        setIsArchivedValidationModalOpened,
    ] = React.useState<boolean>(false);
    const [isValidateClicked, setIsValidateClicked] = React.useState<boolean>(
        false
    );
    const [isActive, setIsActive] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (isValidateClicked) {
            handleArchivePaymentMethods(
                isActive,
                selectedRows,
                franchiseID,
                setIsArchivedValidationModalOpened,
                userID,
                operatorID,
                uuidUser,
                setIsValidateClicked,
                fetchGlobal
            );
        }
        // eslint-disable-next-line
    }, [isValidateClicked, isActive]);

    return (
        <div className="d-flex justify-content-start align-items-center ml-2">
            {modify === true ? (
                <>
                    {isAddChoiceClicked !== true ? (
                        <span
                            onClick={() => {
                                setIsAddChoiceClicked(!isAddChoiceClicked);
                                setLocalFilterActive(false);
                            }}
                            className={`${classnames(
                                "w-100 ml-2 cmn_btn_openForm",
                                {
                                    "not-allowed-icon__clz":
                                        isArchivedPaymentMethodsClicked ||
                                        isLoading,
                                }
                            )}`}
                        >
                            <CustomMainColorButtonWithIcon
                                icon="PlusIcon"
                                iconPosition="left"
                                rounded
                                onClick={() => {
                                    setIsInlineErrorCleared(
                                        !isInlineErrorCleared
                                    );
                                }}
                            >
                                {t("Add a payment method")}
                            </CustomMainColorButtonWithIcon>
                        </span>
                    ) : (
                        <div className="d-flex justify-content-start">
                            <CustomMainColorIconButton
                                icon="PlusIcon"
                                className="mdr_btn_FRreset"
                                rounded
                                disabled={choice.length === 0 ? false : true}
                                onClick={() => {
                                    if (isEdited === true) {
                                        setIsInInitializationModalOpened(true);
                                    } else {
                                        setIsInlineErrorCleared(true);
                                    }
                                }}
                            >
                                <PlusIcon height={20} width={20} fill="white" />
                            </CustomMainColorIconButton>
                        </div>
                    )}
                </>
            ) : null}

            <VerticalDotsIcon
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                style={{ cursor: "pointer" }}
                height={25}
                width={25}
                fill="black"
                className="cmn_drp_FRmenu"
            />
            <div
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton mdr_drp_FRbuttonMenu"
            >
                <div
                    style={{ cursor: "pointer" }}
                    className={classnames(
                        "dropdown-item pl-1 cmn_btn_FRlistActivated"
                    )}
                    onClick={() => {
                        if (isEdited === true) {
                            setIsActionsClicked(!isActionsClicked);
                            setActions(() => {
                                setIsEdited(false);
                                clearData();
                                clearMultiCustomSelectionData();
                                setIsAddChoiceClicked(false);
                                setIsArchivedPaymentMethodsClicked(false);
                            });
                        } else {
                            setIsAddChoiceClicked(false);
                            setIsArchivedPaymentMethodsClicked(false);
                        }
                    }}
                >
                    {t("Enabled payment methods")}({numberActive})
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    className={classnames(
                        "dropdown-item pl-1 cmn_btn_FRlistArchived"
                    )}
                    onClick={() => {
                        if (isEdited === true) {
                            setIsActionsClicked(!isActionsClicked);
                            setActions(() => {
                                setIsAddChoiceClicked(false);
                                setIsEdited(false);
                                clearData();
                                clearMultiCustomSelectionData();
                                setIsArchivedPaymentMethodsClicked(true);
                            });
                        } else {
                            setIsAddChoiceClicked(false);
                            setIsArchivedPaymentMethodsClicked(true);
                        }
                    }}
                >
                    {t("Archived payment methods")}({numberArchived})
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    className={`${classnames(
                        "dropdown-item pl-1 cmn_btn_FRhistory",
                        {
                            "not-allowed-icon__clz":
                                selectedRows.length === 0 || isLoading,
                        }
                    )}`}
                    onClick={() => {
                        if (isEdited === true) {
                            setIsActionsClicked(!isActionsClicked);
                            setActions(() => {
                                setIsEdited(false);
                                clearData();
                                clearMultiCustomSelectionData();
                                setIsAddChoiceClicked(false);
                                if (selectedRows.length === 1) {
                                    ErrorToast(
                                        `${t(
                                            "Attention, it is a multiple action. Please select at least two items"
                                        )!}`
                                    );
                                } else {
                                    setIsHistoryModalOpened(
                                        !isHistoryModalOpened
                                    );
                                }
                            });
                        } else {
                            setIsAddChoiceClicked(false);
                            if (selectedRows.length === 1) {
                                ErrorToast(
                                    `${t(
                                        "Attention, it is a multiple action. Please select at least two items"
                                    )!}`
                                );
                            } else {
                                setIsHistoryModalOpened(!isHistoryModalOpened);
                            }
                        }
                    }}
                >
                    {t("Historical")}
                </div>
                {modify === true ? (
                    <>
                        <div
                            style={{ cursor: "pointer" }}
                            className={`${classnames("dropdown-item pl-1", {
                                "not-allowed-icon__clz":
                                    selectedRows.length === 0 ||
                                    (isArchivedPaymentMethodsClicked &&
                                        oneShop &&
                                        selectedRows.some((element: any) =>
                                            dataArchive.includes(element.id)
                                        )) ||
                                    isLoading,
                            })}`}
                            onClick={async () => {
                                setIsLoading(true);
                                let isArchived = await isSaleSupportArchived(
                                    i18nextLng,
                                    selectedRows,
                                    userID,
                                    shopId,
                                    franchiseID,
                                    fetchGlobal
                                );

                                if (isEdited === true) {
                                    setIsActionsClicked(!isActionsClicked);
                                    setActions(() => {
                                        setIsLoading(false);
                                        setIsAddChoiceClicked(false);
                                        setIsEdited(false);
                                        clearData();
                                        clearMultiCustomSelectionData();
                                        if (selectedRows.length === 1) {
                                            ErrorToast(
                                                `${t(
                                                    "Attention, it is a multiple action. Please select at least two items"
                                                )!}`
                                            );
                                        } else if (
                                            isArchived === true &&
                                            isArchivedPaymentMethodsClicked
                                        ) {
                                            ErrorToast(
                                                `${t(
                                                    "Please note that  the unarchiving process could not be successfully completed. Please check the settings of the store(s) data."
                                                )!}`
                                            );
                                        } else if (
                                            !isArchivedPaymentMethodsClicked
                                        ) {
                                            paymentMethodExistInShops(
                                                shopsPaymentMethodsData,
                                                selectedRows,
                                                isArchivedPaymentMethodsClicked,
                                                setIsArchivedValidationModalOpened,
                                                oneShop,
                                                franchiseID,
                                                userID,
                                                operatorID,
                                                uuidUser,
                                                setIsValidateClicked,
                                                fetchGlobal
                                            );
                                            setIsActive(true);
                                        } else {
                                            PaymentMethodExistInShopsActivated(
                                                shopsPaymentMethodsData,
                                                selectedRows,
                                                isModalConfirmationOpened,
                                                setIsModalConfirmationOpened,
                                                isArchivedPaymentMethodsClicked,
                                                setIsArchivedValidationModalOpened,
                                                franchiseID,
                                                userID,
                                                operatorID,
                                                uuidUser,
                                                setIsValidateClicked,
                                                oneShop,
                                                fetchGlobal
                                            );
                                            setIsActive(false);
                                        }
                                    });
                                } else {
                                    setIsAddChoiceClicked(false);

                                    if (selectedRows.length === 1) {
                                        ErrorToast(
                                            `${t(
                                                "Attention, it is a multiple action. Please select at least two items"
                                            )!}`
                                        );
                                        setIsLoading(false);
                                    } else if (
                                        isArchived === true &&
                                        isArchivedPaymentMethodsClicked
                                    ) {
                                        ErrorToast(
                                            `${t(
                                                "Please note that  the unarchiving process could not be successfully completed. Please check the settings of the store(s) data."
                                            )!}`
                                        );
                                        setIsLoading(false);
                                    } else if (
                                        !isArchivedPaymentMethodsClicked
                                    ) {
                                        paymentMethodExistInShops(
                                            shopsPaymentMethodsData,
                                            selectedRows,
                                            isArchivedPaymentMethodsClicked,
                                            setIsArchivedValidationModalOpened,
                                            oneShop,
                                            franchiseID,
                                            userID,
                                            operatorID,
                                            uuidUser,
                                            setIsValidateClicked,
                                            fetchGlobal
                                        );
                                        setIsActive(true);
                                    } else {
                                        PaymentMethodExistInShopsActivated(
                                            shopsPaymentMethodsData,
                                            selectedRows,
                                            isModalConfirmationOpened,
                                            setIsModalConfirmationOpened,
                                            isArchivedPaymentMethodsClicked,
                                            setIsArchivedValidationModalOpened,
                                            franchiseID,
                                            userID,
                                            operatorID,
                                            uuidUser,
                                            setIsValidateClicked,
                                            oneShop,
                                            fetchGlobal
                                        );
                                        setIsActive(false);
                                    }
                                }
                            }}
                        >
                            <span
                                className={classnames(
                                    "cmn_btn_FRarchived cmn_btn_FRunarchive",
                                    {
                                        "not-allowed-icon__clz": isLoading,
                                    }
                                )}
                            >
                                {isArchivedPaymentMethodsClicked
                                    ? t("Unarchive")
                                    : t("Archive")}
                            </span>
                        </div>
                    </>
                ) : null}
            </div>
            {isArchivedValidationModalOpened ? (
                <ArchivedValidationModal
                    text={t(
                        "Attention, this (these) payment method can be used by other modules.\n\nDo you want to confirm the archiving of the selected of payment method(s)"
                    )}
                    isModalOpened={isArchivedValidationModalOpened}
                    setIsModalOpened={setIsArchivedValidationModalOpened}
                    setIsValidateClicked={setIsValidateClicked}
                />
            ) : null}
        </div>
    );
}
